import { Component, OnDestroy, OnInit } from '@angular/core';
import { CoinsService } from '@http/coins.service';
import { TokenService } from '@http/token.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-restricted-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class RestrictedLayoutComponent implements OnInit, OnDestroy {
  private destroyed$!: Subject<void>;

  constructor(
    private coinsService: CoinsService,
    private tokenService: TokenService,
  ) {
    this.destroyed$ = new Subject<void>();

    this.coinsService.updateSupportedCoins().pipe(takeUntil(this.destroyed$)).subscribe();
    this.tokenService.updateSupportedTokens().pipe(takeUntil(this.destroyed$)).subscribe();
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
